import { useAuthContext } from '../contexts/AuthContext';

/** Роль из API приходит строкой в произвольном регистре; админ — только точное 'admin'. */
export const isAdminRole = (role: unknown): boolean => typeof role === 'string' && role.toLowerCase() === 'admin';

/**
 * Единственный источник правды «текущий пользователь — админ» (AIT-402).
 * Гость и неавторизованный — всегда false, даже если в контексте остался старый user.
 */
export function useIsAdmin(): boolean {
  const { isAuthenticated, user } = useAuthContext();
  return isAuthenticated && isAdminRole(user?.role);
}
